module.exports = __webpack_public_path__ + "img/noData.c8ea66e2.png";